// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  background: rgba(0, 0, 0, 0.4);
}

.wrapper-selected-emails {
  display: flex;
  flex-wrap: wrap;
}

.selected-emails {
  background-color: #FC8955;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  margin-right: 8px;
  margin-bottom: 4px;
}
.selected-emails .icon-unselect {
  font-size: 12px;
}

.text-bold {
  font-weight: bold !important;
}

.ori-emails {
  background-color: #1C5FAB;
}

th.table-th-total_time, td.table-td-total_time {
  width: 18em;
}

.sparepart--qty input {
  flex: 0 0 auto;
  width: 50px;
}

.btn-upload ::ng-deep .p-button.p-fileupload-choose {
  padding: 5px;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-icon {
  font-size: 0.7rem;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-label {
  font-size: 0.7rem;
}

.folder-name {
  min-width: 8em;
}

.customer-signature, .engineer-signature {
  border: solid #979797 1px;
}

.signatureList {
  border: solid #979797 1px;
  margin: 10px 0px;
}

.modal-dialog-lg {
  max-width: 700px;
}

.timeline-overview {
  display: flex;
  margin-top: 18px;
}
.timeline-overview > * {
  flex: 1;
}
.timeline-overview .timeline-overview--text {
  text-align: right;
}
.timeline-overview .timeline-overview--value {
  border-top: 2px solid #979797;
  border-bottom: 2px solid #979797;
  text-align: center;
  margin-left: 15px;
}

.physical-document-checkbox, .radio-field {
  margin: 5px 10px;
}

.physical-document-checkbox ::ng-deep .p-checkbox .p-checkbox-box {
  background: rgb(180, 180, 180);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
